import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.8 13.795c0-.66.535-1.195 1.197-1.195h8.406c.661 0 1.197.536 1.197 1.195v6.61c0 .66-.536 1.195-1.197 1.195h-8.406a1.197 1.197 0 0 1-1.197-1.195zm1.2.306v5.998c0 .163.134.301.299.301H20.1a.3.3 0 0 0 .299-.3v-6c0-.162-.134-.3-.3-.3H12.3a.3.3 0 0 0-.3.3m-9.6-.306c0-.66.541-1.195 1.205-1.195h4.79A1.2 1.2 0 0 1 9.6 13.795v6.61c0 .66-.541 1.195-1.205 1.195h-4.79A1.2 1.2 0 0 1 2.4 20.405zm1.2.306v5.998c0 .163.134.301.3.301h4.2c.161 0 .3-.135.3-.3v-6c0-.162-.135-.3-.3-.3H3.9c-.162 0-.3.135-.3.3M15 3.595c0-.66.54-1.195 1.195-1.195h4.21c.66 0 1.195.536 1.195 1.195v6.61c0 .66-.54 1.195-1.195 1.195h-4.21c-.66 0-1.195-.536-1.195-1.195zm1.2.306v5.998c0 .163.135.301.302.301h3.596a.304.304 0 0 0 .302-.3v-6c0-.162-.135-.3-.302-.3h-3.596a.304.304 0 0 0-.302.3M2.4 3.595c0-.66.534-1.195 1.198-1.195h9.003c.662 0 1.199.536 1.199 1.195v6.61c0 .66-.535 1.195-1.199 1.195H3.598A1.197 1.197 0 0 1 2.4 10.205zm1.2.306v5.998c0 .163.134.301.3.301h8.4a.3.3 0 0 0 .3-.3v-6c0-.162-.134-.3-.3-.3H3.9a.3.3 0 0 0-.3.3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }